import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readObjectArray,
  readString,
  splitKnown,
} from "../utils";
import { ProductVersionCompanyLogoLabelModel } from "./ProductVersionCompanyLogoLabelModel";
import { ProductVersionLabelColorModel } from "./ProductVersionLabelColorModel";

export class ProductVersionLabelModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    type: { label: "Type", fieldType: "text" },
    typeKey: { label: "Type Key", fieldType: "text" },
    positionKey: { label: "Position Key", fieldType: "text" },
    descriptionKey: { label: "Description Key", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  type!: string;
  typeKey!: string;
  positionKey!: string;
  descriptionKey!: string;
  color!: ProductVersionLabelColorModel[];
  companyLogoLabel!: ProductVersionCompanyLogoLabelModel | null;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("type", "");
    this.defineObservableValue("typeKey", "");
    this.defineObservableValue("positionKey", "");
    this.defineObservableValue("descriptionKey", "");
    this.defineObservableValue("color", []);
    this.defineObservableValue("companyLogoLabel", null);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product label");
    this.type = readString(source, "type");
    this.typeKey = readString(source, "typeKey");
    this.positionKey = readString(source, "positionKey");
    this.descriptionKey = readString(source, "descriptionKey");
    this.color = readObjectArray(source, "color").map((entry) =>
      new ProductVersionLabelColorModel().restore(entry)
    );
    this.companyLogoLabel =
      source.companyLogoLabel &&
      typeof source.companyLogoLabel === "object" &&
      !Array.isArray(source.companyLogoLabel)
        ? new ProductVersionCompanyLogoLabelModel().restore(
            source.companyLogoLabel
          )
        : null;
    this.extra = splitKnown(source, [
      "type",
      "typeKey",
      "positionKey",
      "descriptionKey",
      "color",
      "companyLogoLabel",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.type ? { type: this.type } : {}),
      ...(this.typeKey ? { typeKey: this.typeKey } : {}),
      ...(this.positionKey ? { positionKey: this.positionKey } : {}),
      ...(this.descriptionKey ? { descriptionKey: this.descriptionKey } : {}),
      ...(this.color.length > 0
        ? { color: this.color.map((entry) => entry.save()) }
        : {}),
      ...(this.companyLogoLabel &&
      Object.keys(this.companyLogoLabel.save()).length > 0
        ? { companyLogoLabel: this.companyLogoLabel.save() }
        : {}),
    };
  }
}
